import React from 'react';

import { SS_CONTROL_TYPE } from './constants/form-manager.constants';
import SSCheckBox from './controls/ssCheckbox';
import SSDateBox from './controls/ssDatebox';
import SSDropDown from './controls/ssDropDown';
import SSFileInput from './controls/ssFileInput';
import SSNumericTextBox from './controls/ssNumericTextBox';
import SSRadioButtonList from './controls/ssRadioButtonList';
import SSRegulatoryTermsZoom from './controls/ssRegulatoryTermsZoom';
import SSRepositoryZoom from './controls/ssRepositoryZoom';
import SSScormFileInput from './controls/ssScormFileInput';
import SSSlider from './controls/ssSlider';
import SSSummary from './controls/ssSummary';
import SSTextArea from './controls/ssTextArea';
import SSTextBox from './controls/ssTextBox';
import SSTextView from './controls/ssTextView';
import SSZoom from './controls/ssZoom';

const getInput = (controlType, props) => {
  switch (controlType) {
    case SS_CONTROL_TYPE.RADIO_BUTTON_LIST:
      return <SSRadioButtonList {...props} />;
    case SS_CONTROL_TYPE.DROP_DOWN:
      return <SSDropDown {...props} />;
    case SS_CONTROL_TYPE.TEXT_AREA:
      return <SSTextArea {...props} />;
    case SS_CONTROL_TYPE.TEXT_BOX:
      return <SSTextBox {...props} />;
    case SS_CONTROL_TYPE.CHECK_BOX:
      return <SSCheckBox {...props} />;
    case SS_CONTROL_TYPE.DATE_BOX:
      return <SSDateBox {...props} />;
    case SS_CONTROL_TYPE.NUMERIC_TEXT_BOX:
      return <SSNumericTextBox {...props} />;
    case SS_CONTROL_TYPE.TEXT_VIEW:
      return <SSTextView {...props} />;
    case SS_CONTROL_TYPE.REPOSITORY_ZOOM:
      return <SSRepositoryZoom {...props} />;
    case SS_CONTROL_TYPE.ZOOM:
      return <SSZoom {...props} />;
    case SS_CONTROL_TYPE.REGULATORY_TERMS_ZOOM:
      return <SSRegulatoryTermsZoom {...props} />;
    case SS_CONTROL_TYPE.FILE_INPUT:
      return <SSFileInput {...props} />;
    case SS_CONTROL_TYPE.SCORM_FILE_INPUT:
      return <SSScormFileInput {...props} />;
    case SS_CONTROL_TYPE.SLIDER:
      return <SSSlider {...props} />;
    case SS_CONTROL_TYPE.AI_SUMMARY:
      return <SSSummary {...props} />;

    default:
      return null;
  }
};

export default getInput;
